import { decamelize, camelize } from 'humps';

export const formatToSnakeCase = (roomBasis: string) => decamelize(roomBasis, { separator: '_' });
export const normalizeName = (roomBasis: string) => camelize(roomBasis);
